import { render, staticRenderFns } from "./CouponJoychat.vue?vue&type=template&id=0ffcf472&scoped=true"
import script from "./CouponJoychat.vue?vue&type=script&lang=js"
export * from "./CouponJoychat.vue?vue&type=script&lang=js"
import style0 from "./CouponJoychat.vue?vue&type=style&index=0&id=0ffcf472&prod&lang=less&scoped=true"
import style1 from "./CouponJoychat.vue?vue&type=style&index=1&id=0ffcf472&prod&lang=scss"
import style2 from "./CouponJoychat.vue?vue&type=style&index=2&id=0ffcf472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffcf472",
  null
  
)

export default component.exports